import { useTranslation } from 'react-i18next'
import { TablePaginationProps } from '../../components/common/Table/TablePagination'
import { TFunction } from 'i18next'

type UsePaginationConfigProps = Pick<
    TablePaginationProps,
    | 'onRecordsPerPageChange'
    | 'onPageChange'
    | 'siblingCount'
    | 'boundaryCount'
    | 'currentPage'
> & {
    recordsPerPage: number
    totalItems: number
}

export const getRecordsPerPageOptions = (t: TFunction) => [
    {
        value: '10',
        label: t(
            'billing_and_payments.payables_summary.table_pagination.records_per_page',
            { records: 10 }
        ),
    },
    {
        value: '50',
        label: t(
            'billing_and_payments.payables_summary.table_pagination.records_per_page',
            { records: 50 }
        ),
    },
    {
        value: '100',
        label: t(
            'billing_and_payments.payables_summary.table_pagination.records_per_page',
            { records: 100 }
        ),
    },
]

export const usePaginationConfig = ({
    totalItems,
    onPageChange,
    onRecordsPerPageChange,
    siblingCount,
    boundaryCount,
    currentPage,
    recordsPerPage,
}: UsePaginationConfigProps): TablePaginationProps => {
    const { t } = useTranslation('translations')
    const totalPages = Math.ceil(totalItems / recordsPerPage)
    const recordsPerPageOptions = getRecordsPerPageOptions(t)

    return {
        firstPageButtonLabel: t(
            'billing_and_payments.payables_summary.table_pagination.first_page_button_label'
        ),
        lastPageButtonLabel: t(
            'billing_and_payments.payables_summary.table_pagination.last_page_button_label'
        ),
        nextPageButtonLabel: t(
            'billing_and_payments.payables_summary.table_pagination.next_page_button_label'
        ),
        previousPageButtonLabel: t(
            'billing_and_payments.payables_summary.table_pagination.previous_page_button_label'
        ),
        recordsPerPage: recordsPerPage.toString(),
        name: 'payable-summary-table-pagination',
        currentPage,
        totalPages,
        siblingCount,
        boundaryCount,
        onPageChange,
        recordsPerPageOptions,
        onRecordsPerPageChange,
    }
}
